module.exports = __webpack_public_path__ + "img/minus-icon.ae4724db.svg";